var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeemgLogosMonogram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f9c119;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #f68521;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M420.42,319.67v-126.24c0-19.65-10.21-37.42-27.21-47.25l-109.61-63.12c-17.01-9.83-37.8-9.83-54.43,0l-109.23,63.12c-17.01,9.83-27.21,27.59-27.21,47.25v126.24c0,19.65,10.21,37.42,27.21,47.25l109.23,63.12c17.01,9.83,37.8,9.83,54.43,0l109.23-63.12c17.01-9.83,27.59-27.97,27.59-47.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M273.39,166.97h-33.64c-6.43,0-12.47,3.4-15.87,9.07l-16.63,29.1c-3.4,5.67-3.4,12.85,0,18.52l16.63,29.1c3.4,5.67,9.45,9.07,15.87,9.07h33.64c6.43,0,12.47-3.4,15.87-9.07l16.63-29.1c3.4-5.67,3.4-12.85,0-18.52l-16.63-29.1c-3.4-5.67-9.45-9.07-15.87-9.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M273.39,268.27h-33.64c-6.43,0-12.47,3.4-15.87,9.07l-16.63,29.1c-3.4,5.67-3.4,12.85,0,18.52l16.63,29.1c3.4,5.67,9.45,9.07,15.87,9.07h33.64c6.43,0,12.47-3.4,15.87-9.07l16.63-29.1c3.4-5.67,3.4-12.85,0-18.52l-16.63-29.1c-3.4-5.67-9.45-9.07-15.87-9.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M293.8,261.84l122.46-91.09s63.88-54.43,74.84-18.9c10.96,35.91-27.21,114.9-197.3,109.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.21,261.84l-122.46-91.09s-63.88-54.43-74.84-18.9c-10.96,35.53,26.84,114.9,197.3,109.99Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeemgLogosMonogram);
export default __webpack_public_path__ + "static/media/beemg-logos-monogram.4c1cc30aa9cb6b4deb4a4b5db008249b.svg";
export { ForwardRef as ReactComponent };